module.exports = __webpack_public_path__ + "img/card10.be601f15.png";